import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { uploadFnfLetters } from "../../api/resignationChecklist";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../actions/alert";
import { handleAxiosError } from "../../config/action-config";
import {
  FnfProcessChecklistById,
  FnfProcessChecklistSubmit,
} from "../../api/resignationCheckliistAssign";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Paper } from "@material-ui/core";
import { getLatestStatusDetailsById } from "../../api/resignation";

export default function FNFProcessView() {
  const [loader, setLoader] = useState(false);
  const params = useParams();
  const ref = useRef();
  const [isSelected, setIsSelected] = useState(false);
  const [isdoc, setIsDoc] = useState(false);
  const [isrel, setIsRel] = useState(false);
  const [isfnf, setIsFnf] = useState(false);
  const [fnfFile, setFnfFile] = useState({ fnf: "" });
  const [expFile, setExpFile] = useState({ exp: "" });
  const [relFile, setRelFile] = useState({ rel: "" });
  const [empData, setEmpData] = useState({
    last_day_completion: "",
    emp_confirmation_email: "",
    last_working_day: "",
    emp_name: "",
  });
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const date = new Date();
  const relRef = useRef(null);
  const expRef = useRef(null);
  const fnfRef = useRef(null);
  const [prefilledData, setPrefilledData] = useState({});
  const [checkButton, setCheckButton] = useState(false);

  const handleInputChange = (event) => {
    setEmpData({
      ...empData,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    if (params.id) {
      getFnfDataById();
    }
  }, [params.id]);
  async function getFnfDataById() {
    try {
      const { data } = await FnfProcessChecklistById(params.id, user.token);
      if (data.data.length) {
        setPrefilledData(data.data[0]);
        setEmpData({
          last_day_completion: data.data[0].last_day_completion,
          emp_confirmation_email: data.data[0].emp_email_confirmation,
          last_working_day: data.data[0].last_working_day,
          emp_name: data.data[0].employee_name,
        });
        setCheckButton(true);
      } else {
        setCheckButton(false);
      }
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const handleimageUpload = async (event, type) => {
    setLoader(false);
    const file = event.target.files?.[0];
    const formData = new FormData();
    formData.append("letter_type", type);
    formData.append("files", file);
    if (type === "fnf") {
      setFnfFile({ fnf: file.name });
    } else if (type === "exp") {
      setExpFile({ exp: file.name });
    } else if (type === "rel") {
      setRelFile({ rel: file.name });
    }
    try {
      const { data } = await uploadFnfLetters(params.id, formData, user.token);

      if (type === "fnf") {
        setIsFnf(true);
      } else if (type === "exp") {
        setIsRel(true);
      } else if (type === "rel") {
        setIsDoc(true);
      }

      dispatch(showAlert(data.msg));

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleAxiosError(error, dispatch);
    }
  };
  const onSubmit = async (event) => {
    event.preventDefault();
    if (!empData.last_day_completion || !empData.emp_confirmation_email) {
      dispatch(showAlert("Please fill in all required fields."));
      return;
    }
    if (!fnfFile.fnf || !expFile.exp || !relFile.rel) {
      dispatch(showAlert("All documents are required."));
      return;
    }
    try {
      const { data } = await FnfProcessChecklistSubmit(
        empData,
        params.id,
        user.token
      );

      setEmpData({
        last_day_completion: "",
        emp_confirmation_email: "",
      });
      navigate(-2);
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  };
  useEffect(() => {
    if (params?.id) {
      getLatestStatus();
    } else {
      navigate("/resignation-request");
    }
  }, []);
  const [latestStatus, setLatestStatus] = useState("");
  async function getLatestStatus() {
    try {
      const { data } = await getLatestStatusDetailsById(params.id, user.token);
      setLatestStatus(data.data[0].status_details);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "8rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            pl: 1,
            ml: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6">Exit Process</Typography>
          <Box sx={{ display: "flex", columnGap: 1, mr: 1, mt: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate(-2);
              }}
              style={{ padding: "5px 7px" }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
        <Box sx={{ m: 2 }} component="form">
          <form>
            <Grid container spacing={2} className="newTicketTextfield">
              {empData.emp_name && (
                <Grid item xs={12} md={6} sm={6}>
                  <TextField
                    name="Name"
                    fullWidth
                    label="Name"
                    type="text"
                    value={empData.emp_name}
                    disabled
                  />
                </Grid>
              )}

              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  name="last_working_day"
                  fullWidth
                  label="Last Working Day"
                  value={formatDateToYYYYMMDD(empData.last_working_day)}
                  disabled
                  type="date"
                />
              </Grid>

              <Grid item xs={12} md={6} sm={6}>
                <TextField
                  value={empData.emp_confirmation_email}
                  fullWidth
                  name="emp_confirmation_email"
                  onChange={handleInputChange}
                  label="Employee Email (On which letters have mailed)"
                  type="text"
                  // value={open?.data?.employee_email}
                  required
                />
              </Grid>
              {/* 
              <Grid item xs={12} md={6} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="served-last-working-day-label">
                    Is Last Working Day Completed
                  </InputLabel>
                  <Select
                    required
                    value={empData.last_day_completion}
                    label="served last working day"
                    name="last_day_completion"
                    onChange={handleInputChange}
                  >
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                  </Select>
                </FormControl>
              </Grid> */}
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    ref={relRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "rel")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`rel-button-file`}>
                        <Button
                          disabled={
                            prefilledData.releiving_letter ? true : false
                          }
                          variant="outlined"
                          component="span"
                          startIcon={
                            isdoc === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          className="add-button btn-align-right"
                          onClick={() => relRef.current.click()}
                        >
                          Upload Relieving Letter
                        </Button>
                      </label>

                      {prefilledData.releiving_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.releiving_letter}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            borderBottom: "1px solid #000",
                          }}
                        >
                          Relieving Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {relFile.rel}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  {" "}
                  <input
                    ref={expRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "exp")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`exp-button-file`}>
                        <Button
                          disabled={
                            prefilledData.experience_letter ? true : false
                          }
                          variant="outlined"
                          component="span"
                          startIcon={
                            isrel === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          className="add-button btn-align-right"
                          onClick={() => expRef.current.click()}
                        >
                          Upload Experience Letter
                        </Button>
                      </label>
                      {prefilledData.experience_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.experience_letter}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            borderBottom: "1px solid #000",
                          }}
                        >
                          Experience Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {expFile.exp}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sm={12}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    ref={fnfRef}
                    accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: "none" }}
                    type="file"
                    onChange={(e) => handleimageUpload(e, "fnf")}
                  />
                  {loader === true ? (
                    <Loading />
                  ) : (
                    <>
                      <label htmlFor={`fnf-button-file`}>
                        <Button
                          disabled={prefilledData.fnf_letter ? true : false}
                          variant="outlined"
                          component="span"
                          startIcon={
                            isfnf === true ? (
                              <CheckCircleIcon color="success" />
                            ) : (
                              <CloudUploadIcon />
                            )
                          }
                          onClick={() => fnfRef.current.click()}
                          className="add-button btn-align-right"
                        >
                          Upload FNF Letter
                        </Button>
                      </label>
                      {prefilledData.fnf_letter ? (
                        <Link
                          to={`https://cloudapps.vastedge.com/${prefilledData.fnf_letter}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            textDecoration: "none",
                            borderBottom: "1px solid #000",
                          }}
                        >
                          FNF Letter
                        </Link>
                      ) : (
                        <Typography variant="body1" style={{ marginLeft: 10 }}>
                          {fnfFile.fnf}
                        </Typography>
                      )}
                    </>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Button
                    sx={{ ml: 1, mb: 1 }}
                    onClick={() => {
                      navigate(-2);
                    }}
                    className="cancel-button"
                  >
                    Cancel
                  </Button>
                  {latestStatus === "ASSET_SUBMITTED" &&
                    compareDate(empData.last_working_day) && (
                      <Button
                        sx={{ ml: 1, mb: 1 }}
                        // disabled={/^Trial_User$/i.test(user.role) ? true : false}
                        // onClick={handleSubmit(onNewTicketSubmit)}
                        type="submit"
                        className="blue-button"
                        onClick={onSubmit}
                      >
                        Submit
                      </Button>
                    )}
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Paper>
    </Box>
  );
}
function Loading() {
  return (
    <Box sx={{ display: "flex" }}>
      <CircularProgress />
    </Box>
  );
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
function compareDate(date) {
  const argumentDate = new Date(date.substring(0, 10));
  const currentDate = new Date();
  argumentDate.setHours(0, 0, 0, 0);
  currentDate.setHours(0, 0, 0, 0);
  console.log(currentDate, argumentDate);
  console.log(currentDate >= argumentDate);
  return currentDate >= argumentDate; // Adjusted comparison operator
}
